<a class="play-video small" routerLink="{{href}}">
  <i class="fa fa-play" aria-hidden="true"></i>
  <div class="shade">
    <ng-content></ng-content>
  </div>
</a>